import React from "react"
import types from "prop-types"
import SelectionDropZone from "./DragAndDrop/SelectionDropZone"

const SelectableOptions = ({
  ref = undefined,
  ...rest
}) => (
  <SelectionDropZone
    className="px-4 py-2 space-y-10"
    ref={ref}
    {...rest}
  />
)

SelectableOptions.displayName = "SelectableOptions"

SelectableOptions.propTypes = {
  ref: types.oneOfType([types.func, types.object]),
}

export default SelectableOptions
